document.addEventListener('alpine:init', () => {
  function detailsElement(data = {}) {
    return {
      ...data,

      id: data.id || null,
  
      isOpen: this.$el.hasAttribute('open'),

      init() {
        this.$el.addEventListener('toggle', () => {
          this.isOpen = this.$el.hasAttribute('open');

          if (this.scrollToTop) {
            window.scrollTo({ top: 0 });
          }
        });

        document.addEventListener(`detailselementtoggleclick${this.id}`, () => {
          !this.isOpen && this.toggle();
        });
      },

      toggle() {
        if (this.$root.hasAttribute('open')) {
          this.$root.removeAttribute('open');
        } else {
          this.$root.setAttribute('open', '');
        }
      }
    };
  };
  
  Alpine.data('detailsElement', detailsElement);
});
